import * as React from 'react';
import {
  DateRangeTypeOption,
  IDateRange,
} from '../../../../data/providers/settings/dates/dateRangeProvider';
import { IRange } from '../../../../data/types';
import { CardHeader, CardHeaderLeft } from '../../../shared/card/CardHeader';
import { DateSelect } from '../../../shared/form/selects/DateRangeSelect';
import { Step } from '../../../shared/form/Step';
import { FormSection } from './FormSection';

interface IProps {
  onTimeframeChange: (timeframe: IDateRange) => void;
  timeframe: IDateRange;
  step?: number;
  id?: string;
}

export const TimeframeSelector = (props: IProps): React.ReactElement => {
  const dateRangeChangeHandler = (
    dateType: DateRangeTypeOption,
    dateRange: IRange
  ): void => {
    props.onTimeframeChange({
      dateType,
      dateRange: dateRange ?? null,
    });
  };

  return (
    <FormSection>
      <CardHeader>
        <CardHeaderLeft>
          {props.step && <Step>{props.step}</Step>}
          <h6>Select Timeframe</h6>
        </CardHeaderLeft>
      </CardHeader>
      <div style={{ padding: '10px' }}>
        <DateSelect
          type='inclusive'
          dateRangeType={props.timeframe?.dateType}
          dateRange={props.timeframe?.dateRange}
          onChange={dateRangeChangeHandler}
          id={props.id}
        />
      </div>
    </FormSection>
  );
};
